import * as React from 'react'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Ruler from '../../00-Primitives/Ruler'
import baseStyle from '../style.scss'

type Props = {
  bodyText: string
  headlineText: string
  availabilityText: string
}

function SoldOutCTA({ bodyText, headlineText, availabilityText }: Props) {
  return (
    <div className={baseStyle.wrapper}>
      <div className={baseStyle.content}>
        <HeadlineTwo className={baseStyle.headlineText}>
          {headlineText}
        </HeadlineTwo>
        <Ruler className={baseStyle.ruler} />
        <Paragraph className={baseStyle.bodyText}>{bodyText}</Paragraph>
        <div className={baseStyle.availabilityText}>{availabilityText}</div>
      </div>
    </div>
  )
}

export default SoldOutCTA
